import { defineMessages } from 'react-intl'
import { formatMessage } from 'locale.js'

const localizedRoleNames = defineMessages({
    commander: {
        id: 'clanmanagement.roles.commander',
        defaultMessage: 'Командующий',
    },
    executive_officer: {
        id: 'clanmanagement.roles.executive_officer',
        defaultMessage: 'Заместитель командующего',
    },
    personnel_officer: {
        id: 'clanmanagement.roles.personnel_officer',
        defaultMessage: 'Офицер штаба',
    },
    quartermaster: {
        id: 'clanmanagement.roles.quartermaster',
        defaultMessage: 'Офицер снабжения',
    },
    intelligence_officer: {
        id: 'clanmanagement.roles.intelligence_officer',
        defaultMessage: 'Офицер разведки',
    },
    recruitment_officer: {
        id: 'clanmanagement.roles.recruitment_officer',
        defaultMessage: 'Военком',
    },
    combat_officer: {
        id: 'clanmanagement.roles.combat_officer',
        defaultMessage: 'Командир подразделения',
    },
    junior_officer: {
        id: 'clanmanagement.roles.junior_officer',
        defaultMessage: 'Младший офицер',
    },
    'private': {
        id: 'clanmanagement.roles.private',
        defaultMessage: 'Боец',
    },
    recruit: {
        id: 'clanmanagement.roles.recruit',
        defaultMessage: 'Новобранец',
    },
    reservist: {
        id: 'clanmanagement.roles.reservist',
        defaultMessage: 'Резервист',
    },
})

// This permissions are equal to clans.roles permissions.
export const permissions = {
    DIVIDE_PROFITS: 'divide_profits',
    CHANGE_ROLE: 'change_role',
    CHANGE_COMMANDER: 'change_commander',
    REMOVE_MEMBER: 'remove_member',
    HANDLE_INVITES: 'handle_invites',
}

export const QUARTERMASTER = 'quartermaster'

const roles = Object.freeze({
    commander: {
        rank: 10,
        order: 0,
        permissions: [
            permissions.DIVIDE_PROFITS,
            permissions.CHANGE_ROLE,
            permissions.CHANGE_COMMANDER,
            permissions.REMOVE_MEMBER,
            permissions.HANDLE_INVITES,
        ],
    },
    executive_officer: {
        rank: 9,
        order: 1,
        permissions: [
            permissions.DIVIDE_PROFITS,
            permissions.CHANGE_ROLE,
            permissions.REMOVE_MEMBER,
            permissions.HANDLE_INVITES,
        ],
    },
    personnel_officer: {
        rank: 8,
        order: 2,
        permissions: [
            permissions.CHANGE_ROLE,
            permissions.REMOVE_MEMBER,
            permissions.HANDLE_INVITES,
        ],
    },
    quartermaster: {
        rank: 8,
        order: 5,
        permissions: [
            permissions.DIVIDE_PROFITS,
        ],
    },
    intelligence_officer: {
        rank: 7,
        order: 4,
        permissions: [],
    },
    recruitment_officer: {
        rank: 5,
        order: 6,
        permissions: [
            permissions.HANDLE_INVITES,
        ],
    },
    combat_officer: {
        rank: 4,
        order: 3,
        permissions: [
            permissions.CHANGE_ROLE,
        ],
    },
    junior_officer: {
        rank: 3,
        order: 7,
        permissions: [],
    },
    'private': {
        rank: 2,
        order: 8,
        permissions: [],
    },
    recruit: {
        rank: 1,
        order: 9,
        permissions: [],
    },
    reservist: {
        rank: 0,
        order: 10,
        permissions: [],
    },
})

export const roleNames = Object.keys(roles)

const getPermissions = (roleName) => {
    const role = roles[roleName]
    return role ? role.permissions : []
}

export const hasPermission = (roleName, permission) => {
    return getPermissions(roleName).includes(permission)
}

export const hasAnyPermission = (roleName, permissions) => {
    const rolePermissions = getPermissions(roleName)
    return permissions.some((permission) => rolePermissions.includes(permission))
}

export const getRank = (roleName) => {
    const role = roles[roleName]
    return role ? role.rank : -1
}

const maxRank = roles.commander.rank
export const getRankSortOrder = (roleName) => {
    const role = roles[roleName]
    return role ? maxRank - role.order : -1
}

export const getLocalizedName = (roleName) => {
    return formatMessage(localizedRoleNames[roleName])
}

export const getAssignableRole = (currentRoleName, selectedRole) => {
    const assignableRoles = getAssignableRoles(currentRoleName)
    if (!assignableRoles.includes(selectedRole)) {
        return assignableRoles[0]
    }
    return selectedRole
}

export const getAssignableRoles = (roleName) => {
    const currentRoleRank = getRank(roleName)
    return roleNames.filter((roleName) => (
        getRank(roleName) < currentRoleRank
    ))
}

export const canManage = (roleName, targetRoleName) => {
    return getRank(targetRoleName) < getRank(roleName)
}



// WEBPACK FOOTER //
// ./utils/clan_management/roles.js